<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
			<div>
				<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">所属系统:</label>
				<el-select  v-model="filterForm.sysCode" placeholder="全部" style="width: 150px;">
					<el-option label="全部" value="all"></el-option>
					<el-option v-for="(item,index) in sysAppList"  v-bind:key="index"  :label="item.name" :value="item.key"></el-option>
				</el-select>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">所属项目:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 150px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点类型:</label>
				<el-select   v-model="filterForm.deviceModel" style="width: 220px"> 
					<el-option label="全部" value="all"></el-option>
					<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				</el-select>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点搜索:</label>
				<el-input style="width: 180px;" placeholder="输入点名称/编号" v-model="filterForm.search_word">
				</el-input>
				<el-button style="margin-left: 15px;" @click="queryBtn()">查询</el-button>
			</div>
		</el-col>
		<el-col :span="24" class="toolbar" style="padding: 0px;padding-bottom:2px;margin: 5px 0px;">
			<el-button v-if="permissionNodeList.terminal_add.hasEntitle == 1" @click="handleAdd">新增传感器</el-button>
			<el-button v-if="permissionNodeList.terminal_del.hasEntitle == 1" @click="handleBatchDelete">删除传感器</el-button>
			<el-button v-if="permissionNodeList.terminal_import.hasEntitle == 1" @click="handleBatchImport">批量导入</el-button>
			<el-button  v-if="permissionNodeList.terminal_export.hasEntitle == 1" @click="exportData">数据导出</el-button>
		</el-col>
		<el-dialog title="批量导入项目" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column  type="selection" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="120" sortable>
			</el-table-column>
			<el-table-column prop="name" label="传感器名称" width="160"  sortable>
			</el-table-column>
			<el-table-column prop="sn" label="传感器编号" width="100" sortable>
			</el-table-column>
			<el-table-column prop="deviceModelName" label="传感器类型" width="100" sortable>
			</el-table-column>
			<el-table-column prop="routeNum"  label="路数" width="80" sortable>
			</el-table-column>
			<el-table-column prop="address" label="传感器地址" width="140" sortable>
			</el-table-column>
			<el-table-column prop="sysCodeName" label="系统类型" min-width="90" sortable>
			</el-table-column>
			<el-table-column label="操作" width="280">
				<template scope="scope">
					<el-button size="small" v-if="scope.row.alarmIgnoreAble == '0' && permissionNodeList.terminal_shield.hasEntitle == 1"  @click="handleBlock(scope.$index, scope.row)">屏蔽</el-button>
					<el-button size="small" v-if="scope.row.alarmIgnoreAble == '1' && permissionNodeList.terminal_shield.hasEntitle == 1" @click="handleUnBlock(scope.$index, scope.row)" style="color:#b0b1b3;" >已屏蔽</el-button>
					<el-button size="small" v-if="permissionNodeList.terminal_conf.hasEntitle == 1 && scope.row.deviceModel != 'ECSLZT'" @click="handleSetting(scope.$index, scope.row)">配置</el-button>
					<el-button size="small" v-if="permissionNodeList.terminal_show.hasEntitle == 1 && scope.row.deviceModel != 'ECSLZT'" @click="handleShowSetting(scope.$index, scope.row)">查看配置</el-button>
					<el-button size="small" v-if="permissionNodeList.terminal_edit.hasEntitle == 1" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增界面-->
		<el-dialog title="新增传感器" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="saveFormRules" ref="addForm">
				<el-form-item prop="name" label="传感器名称">
					<el-input v-model="addForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="传感器编号">
					<el-input v-model="addForm.sn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="传感器地址">
					<el-input v-model="addForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="versionNumber" label="传感器版本" >
					<el-input v-model="addForm.versionNumber" auto-complete="off" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="传感器类型"  prop="deviceModel">
					<el-select   v-model="addForm.deviceModel" style="width: 300px"> 
						<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="rangeUpper" v-if="(addForm.deviceModel =='D4ACZT-T') || (addForm.deviceModel =='D4ACZT')"  label="量程上限" >
					<el-input v-model="addForm.rangeUpper" auto-complete="off" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;" v-if="addForm.deviceModel =='D4ACZT-T'">℃</label>
				</el-form-item>
				<el-form-item prop="rangeLower" v-if="addForm.deviceModel =='D4ACZT-T' || (addForm.deviceModel =='D4ACZT')" label="量程下限" >
					<el-input v-model="addForm.rangeLower" auto-complete="off" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;" v-if="addForm.deviceModel =='D4ACZT-T'">℃</label>
				</el-form-item>
				<el-form-item v-if="addForm.deviceModel =='OC16ZT'" prop="routeNum" label="路数">
					<el-select  v-model="addForm.routeNum" placeholder="请选择" style="width: 300px">
						<el-option  label="1" value="1"></el-option>
						<el-option  label="2" value="2"></el-option>
						<el-option  label="3" value="3"></el-option>
						<el-option  label="4" value="4"></el-option>
						<el-option  label="5" value="5"></el-option>
						<el-option  label="6" value="6"></el-option>
						<el-option  label="7" value="7"></el-option>
						<el-option  label="8" value="8"></el-option>
						<el-option  label="9" value="9"></el-option>
						<el-option  label="10" value="10"></el-option>
						<el-option  label="11" value="11"></el-option>
						<el-option  label="12" value="12"></el-option>
						<el-option  label="13" value="13"></el-option>
						<el-option  label="14" value="14"></el-option>
						<el-option  label="15" value="15"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item v-if="addForm.deviceModel =='D4ACZT'" prop="unit" label="单位" >
					<el-input v-model="addForm.unit" auto-complete="off" style="width: 300px"></el-input>
				</el-form-item>
				
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="addForm.projectId"  filterable placeholder="请选择" style="width: 300px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item v-if="addForm.deviceModel !='ECSLZT'" label="系统类型"  prop="sysCode">
					<el-select   v-model="addForm.sysCode" placeholder="请选择" style="width: 300px">
				        <el-option v-for="(item,index) in sysAppList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item v-if="addForm.deviceModel =='ECSLZT'" prop="sysCode" label="系统类型">
					<treeselect :multiple="true" :options="sysAppListForTree"  valueFormat="id" style="width:240px;" placeholder="请选择"  v-model="addForm.sysCode" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑传感器" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="saveFormRules" ref="editForm">
				<el-form-item prop="name" label="传感器名称">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="传感器编号">
					<el-input v-model="editForm.sn" auto-complete="off" disabled></el-input>
				</el-form-item>
				<el-form-item prop="address" label="传感器地址">
					<el-input v-model="editForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="versionNumber" label="传感器版本" >
					<el-input v-model="editForm.versionNumber" auto-complete="off" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item label="传感器类型"  prop="deviceModel">
					<el-select   v-model="editForm.deviceModel" style="width: 300px"> 
						<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="rangeUpper" v-if="(editForm.deviceModel =='D4ACZT-T') || (editForm.deviceModel =='D4ACZT')"  label="量程上限" >
					<el-input v-model="editForm.rangeUpper" auto-complete="off" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;" v-if="addForm.deviceModel =='D4ACZT-T'">℃</label>
				</el-form-item>
				<el-form-item prop="rangeLower" v-if="(editForm.deviceModel =='D4ACZT-T') || (editForm.deviceModel =='D4ACZT')" label="量程下限" >
					<el-input v-model="editForm.rangeLower" auto-complete="off" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;" v-if="addForm.deviceModel =='D4ACZT-T'">℃</label>
				</el-form-item>
				<el-form-item v-if="editForm.deviceModel =='OC16ZT'" prop="routeNum" label="路数">
					<el-select  v-model="editForm.routeNum" placeholder="请选择" style="width: 300px">
						<el-option  label="1" value="1"></el-option>
						<el-option  label="2" value="2"></el-option>
						<el-option  label="3" value="3"></el-option>
						<el-option  label="4" value="4"></el-option>
						<el-option  label="5" value="5"></el-option>
						<el-option  label="6" value="6"></el-option>
						<el-option  label="7" value="7"></el-option>
						<el-option  label="8" value="8"></el-option>
						<el-option  label="9" value="9"></el-option>
						<el-option  label="10" value="10"></el-option>
						<el-option  label="11" value="11"></el-option>
						<el-option  label="12" value="12"></el-option>
						<el-option  label="13" value="13"></el-option>
						<el-option  label="14" value="14"></el-option>
						<el-option  label="15" value="15"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item v-if="editForm.deviceModel =='D4ACZT'" prop="unit" label="单位" >
					<el-input v-model="editForm.unit" auto-complete="off" style="width: 300px"></el-input>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="editForm.projectId"  filterable placeholder="请选择" style="width: 300px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item v-if="editForm.deviceModel !='ECSLZT'" label="系统类型"  prop="sysCode">
					<el-select   v-model="editForm.sysCode" placeholder="请选择" style="width: 300px">
				        <el-option v-for="(item,index) in sysAppList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item v-if="editForm.deviceModel =='ECSLZT'" prop="sysCode" label="系统类型">
					<treeselect :multiple="true" :options="sysAppListForTree"  valueFormat="id" style="width:240px;" placeholder="请选择"  v-model="editForm.sysCode" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled"  @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--屏蔽弹窗-->
		<el-dialog title="屏蔽" v-model="blockFormVisible" :close-on-click-modal="false" @close="cancelBlockSubmit">
			<el-form :model="blockForm" label-width="120px" :rules="blockFormRules" ref="blockForm">
				<el-form-item prop="name" label="传感器名称">
					 <span >{{blockForm.name}}</span>
				</el-form-item>
				<el-form-item label="传感器类型:" prop="deviceModelName">
					<span >{{blockForm.deviceModelName}}</span>
				</el-form-item>
				<el-form-item label="屏蔽开始时间" prop="startTime">
					<el-date-picker  v-model="blockForm.startTime" value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm" type="datetime"  ></el-date-picker>
				</el-form-item>
				<el-form-item label="屏蔽结束时间" prop="endTime">
					<el-date-picker  v-model="blockForm.endTime" value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm" type="datetime"  ></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelBlockSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="blockSubmitButtonDisabled" @click.native="blockSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--配置弹窗-->
		<el-dialog title="配置" v-model="settingFormVisible" :close-on-click-modal="false" @close="cancelSettingSubmit">
			<el-form :model="settingForm" label-width="120px" :rules="settingFormRules" ref="settingForm">
				<el-form-item prop="name" label="传感器名称:">
					 <span >{{settingForm.name}}</span>
				</el-form-item>
				<el-form-item prop="name" label="传感器类型:">
					 <span >{{settingForm.deviceModelName}}</span>
				</el-form-item>
				<el-form-item label="数据类型:" prop="dataType">
						<span v-if="settingForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="告警:" prop="alarmType">
					<el-radio-group v-bind:disabled="settingForm.deviceModel == 'DMZ3ZT'"  v-model="settingForm.alarmType" >
						<el-radio class="radio" :label="0">报警</el-radio>
						<el-radio class="radio"  :label="-1">预警</el-radio>
						<el-radio v-if="settingForm.dataType == '0'"  class="radio" :label="1">预警+报警</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == 0"  label="告警参数:" prop="thresholdType">
					<el-checkbox  v-if="settingForm.deviceModel =='YS-ZN-004-VOC'" v-model="settingForm.thresholdType" >TVOC (ppm)</el-checkbox>
					<el-checkbox  v-if="settingForm.deviceModel =='YS-ZN-010-NH3' || settingForm.deviceModel =='YS-ZN-009-CO'" v-model="settingForm.thresholdType" >ppm</el-checkbox>
					<el-checkbox  v-if="settingForm.deviceModel =='YS-ZN-002-CO2' || settingForm.deviceModel =='YS-ZN-012-H2S'" v-model="settingForm.thresholdType" >%</el-checkbox>
					<el-checkbox  v-if="settingForm.deviceModel =='THZ2ZT'" v-model="settingForm.thresholdType" >温度（℃）</el-checkbox>
					<el-checkbox  v-if="settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5'" v-model="settingForm.thresholdType" >频率（Hz）</el-checkbox>
					<el-radio-group v-if="settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='0'" v-model="settingForm.thresholdType" >
							<el-radio checked disabled class="radio" >{{settingForm.thresholdTypeName}}</el-radio>
					</el-radio-group>
					<el-radio  v-if="settingForm.deviceModel !='THZ2ZT' && settingForm.deviceModel !='VBZ3ZT'" disabled class="radio" >{{settingForm.thresholdTypeName}}</el-radio>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' && (settingForm.alarmType == '0' || settingForm.alarmType == '-1' || settingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="settingForm.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' && settingForm.alarmType == '1'"  label="预警范围:" style="display:inline;">
					<el-input v-model="settingForm.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(settingForm.deviceModel =='THZ2ZT') || (settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5') "  label="告警参数:" prop="otherThresholdType">
					<el-checkbox  v-if="settingForm.deviceModel =='THZ2ZT'" v-model="settingForm.otherThresholdType" >湿度（%）</el-checkbox>
					<el-checkbox  v-if="settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5'" v-model="settingForm.otherThresholdType" >熵值</el-checkbox>
				</el-form-item>	
				<el-form-item v-if="settingForm.deviceModel =='THZ2ZT' || (settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5') && (settingForm.alarmType == '0' || settingForm.alarmType == '-1' || settingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="settingForm.otherLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.otherUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(settingForm.deviceModel =='THZ2ZT' || (settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5')) && (settingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="settingForm.otherEarlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.otherEarlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item label="状态说明"  v-if="settingForm.dataType == '1' && settingForm.deviceModel !='OCZ1ZT47-XY'"  prop="explainModel" style="display:inline;">
					<span>0:</span>
					<el-input v-bind:disabled="settingForm.deviceModel == 'DMZ3ZT'" v-model="settingForm.zeroExplain"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<span style="padding-left:20px;">1:</span>
					<el-input v-bind:disabled="settingForm.deviceModel == 'DMZ3ZT'" v-model="settingForm.oneExplain"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!--吸烟报警器-->
				<el-form-item label="状态说明"  v-if="settingForm.deviceModel == 'OCZ1ZT47-XY'"  prop="explainModel" >
					<span>有人吸烟:</span>
					<el-select v-model="settingForm.oneExplain"  placeholder="请选择" style="width: 300px">
						<el-option  label="通" value="1"></el-option>
						 <el-option  label="断" value="0"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="报警状态"  v-if="settingForm.dataType == '1' && settingForm.deviceModel !='OCZ1ZT47-XY'"  prop="explainModel">
					<el-select v-bind:disabled="settingForm.deviceModel == 'DMZ3ZT'"  v-model="settingForm.explainModel"  placeholder="请选择" style="width: 300px">
				        <el-option  label="无" value="-1"></el-option>
						<el-option  label="0" value="0"></el-option>
						 <el-option  label="1" value="1"></el-option>
						 <el-option  label="01" value="2"></el-option>
				    </el-select>
				</el-form-item>
				<!--吸烟报警器-->
				<el-form-item label="报警状态"  v-if="settingForm.deviceModel == 'OCZ1ZT47-XY'"  prop="explainModel">
					<el-select  v-model="settingForm.explainModel"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="-1"></el-option>
						<!-- <el-option  label="开启" value="0"></el-option> -->
						 <el-option  label="开启" value="1"></el-option>
				    </el-select>
				</el-form-item>
				
				<el-form-item  prop="alarmTimeout" label="告警超时:" >
					<el-input v-model="settingForm.alarmTimeout" auto-complete="off"  placeholder="请输入1-3000的自然数" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">分钟</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelSettingSubmit">取消</el-button>
				<el-button type="primary" v-if="userRoleIdentity == 'admin'" v-bind:disabled="settingSubmitButtonDisabled" @click.native="settingSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--查看配置弹窗-->
		<el-dialog title="查看配置" v-model="showSettingFormVisible" :close-on-click-modal="false" @close="cancelShowSettingSubmit">
			<el-form :model="settingForm" label-width="120px" :rules="settingFormRules" ref="settingForm">
				<el-form-item prop="name" label="传感器名称:">
					 <span >{{settingForm.name}}</span>
				</el-form-item>
				<el-form-item prop="name" label="传感器类型:">
					 <span >{{settingForm.deviceModelName}}</span>
				</el-form-item>
				<el-form-item label="数据类型:" prop="dataType">
						<span v-if="settingForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="告警:" prop="alarmType">
					<el-radio-group disabled  v-model="settingForm.alarmType" >
						<el-radio class="radio" :label="0">报警</el-radio>
						<el-radio class="radio"  :label="-1">预警</el-radio>
						<el-radio v-if="settingForm.dataType == '0'"  class="radio" :label="1">预警+报警</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="告警参数:" prop="thresholdType">
					<el-checkbox disabled v-if="settingForm.deviceModel =='YS-ZN-004-VOC'" v-model="settingForm.thresholdType" >TVOC (ppm)</el-checkbox>
					<el-checkbox disabled v-if="settingForm.deviceModel =='THZ2ZT'" v-model="settingForm.thresholdType" >温度（℃）</el-checkbox>
					<el-checkbox disabled v-if="settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5'" v-model="settingForm.thresholdType" >频率（Hz）</el-checkbox>
					<el-radio-group v-if="settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='0'" v-model="settingForm.thresholdType" >
							<el-radio checked disabled class="radio" >{{settingForm.thresholdTypeName}}</el-radio>
					</el-radio-group>
							<el-radio checked v-if="settingForm.deviceModel !='THZ2ZT' && settingForm.deviceModel !='VBZ3ZT'" disabled class="radio" >{{settingForm.thresholdTypeName}}</el-radio>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' && (settingForm.alarmType == '0' || settingForm.alarmType == '-1' || settingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="settingForm.lowerThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.upperThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' && settingForm.alarmType == '1'"  label="预警范围:" style="display:inline;">
					<el-input v-model="settingForm.earlyLowerThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.earlyUpperThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(settingForm.deviceModel =='THZ2ZT') || (settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5') "  label="告警参数:" prop="otherThresholdType">
					<el-checkbox  disabled v-if="settingForm.deviceModel =='THZ2ZT'"  v-model="settingForm.otherThresholdType" >湿度（%）</el-checkbox>
					<el-checkbox disabled  v-if="settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5'" v-model="settingForm.otherThresholdType" >熵值</el-checkbox>
				</el-form-item>	
				<el-form-item v-if="settingForm.deviceModel =='THZ2ZT' || (settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5') && (settingForm.alarmType == '0' || settingForm.alarmType == '-1' || settingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="settingForm.otherLowerThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.otherUpperThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(settingForm.deviceModel =='THZ2ZT' || (settingForm.deviceModel =='VBZ3ZT' && settingForm.versionNumber =='5')) && (settingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="settingForm.otherEarlyLowerThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.otherEarlyUpperThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item label="状态说明"  v-if="settingForm.dataType == '1' && settingForm.deviceModel !='OCZ1ZT47-XY'"  prop="explainModel" style="display:inline;">
					<span>0:</span>
					<el-input v-model="settingForm.zeroExplain" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<span style="padding-left:20px;">1:</span>
					<el-input v-model="settingForm.oneExplain" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!--吸烟报警器-->
				<el-form-item label="状态说明"  v-if="settingForm.deviceModel == 'OCZ1ZT47-XY'"  prop="explainModel" >
					<span>有人吸烟:</span>
					<el-select disabled v-model="settingForm.oneExplain"  placeholder="请选择" style="width: 300px">
						<el-option  label="通" value="1"></el-option>
						 <el-option  label="断" value="0"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="报警状态" v-if="settingForm.dataType == '1' && settingForm.deviceModel !='OCZ1ZT47-XY'"  prop="explainModel">
					<el-select  v-model="settingForm.explainModel" disabled placeholder="请选择" style="width: 300px">
				        <el-option  label="无" value="-1"></el-option>
						<el-option  label="0" value="0"></el-option>
						<el-option  label="1" value="1"></el-option>
						<el-option  label="01" value="2"></el-option>
				    </el-select>
				</el-form-item>
				<!--吸烟报警器-->
				<el-form-item label="报警状态"  v-if="settingForm.deviceModel == 'OCZ1ZT47-XY'"  prop="explainModel">
					<el-select disabled v-model="settingForm.explainModel"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="-1"></el-option>
						 <!-- <el-option  label="开启" value="0"></el-option> -->
						 <el-option  label="开启" value="1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item  prop="alarmTimeout" label="告警超时:" >
					<el-input v-model="settingForm.alarmTimeout" disabled auto-complete="off"  style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">分钟</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelShowSettingSubmit">取消</el-button>
			</div>
		</el-dialog>

		<!--多组元素-配置弹窗-->
		<el-dialog title="配置" v-model="multSettingFormVisible" :close-on-click-modal="false" @close="cancelMultSettingSubmit">
			<el-form :model="multSettingForm" label-width="160px" :rules="settingFormRules" ref="multSettingForm">
				<el-form-item prop="name" label="传感器名称:">
					 <span >{{multSettingForm.name}}</span>
				</el-form-item>
				<el-form-item prop="name" label="传感器类型:">
					 <span >{{multSettingForm.deviceModelName}}</span>
				</el-form-item>
				<el-form-item label="数据类型:" prop="dataType">
						<span v-if="multSettingForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="告警:"  v-if="isYSZNDeviceType(multSettingForm.deviceModel)" prop="alarmType">
					<el-radio-group  v-model="multSettingForm.alarmType" >
						<el-radio class="radio" :label="0">报警</el-radio>
						<el-radio class="radio"  :label="-1">预警</el-radio>
						<el-radio v-if="multSettingForm.dataType == '0'"  class="radio" :label="1">预警+报警</el-radio>
					</el-radio-group>
				</el-form-item>
                
				  <!-- 硫化氢（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-012-H2S'"  label="告警参数:" >
					<el-radio disabled  >硫化氢浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-012-H2S' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multH2SSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multH2SSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-012-H2S'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multH2SSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multH2SSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				 <!-- 氨气（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-010-NH3'"  label="告警参数:" >
					<el-radio disabled  >氨气浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-010-NH3' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multNH3Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multNH3Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-010-NH3'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multNH3Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multNH3Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 一氧化碳（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-009-CO'"  label="告警参数:" >
					<el-radio disabled  >一氧化碳浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-009-CO' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multC0Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multC0Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-009-CO'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multC0Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multC0Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 二氧化碳（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-002-CO2'"  label="告警参数:" >
					<el-radio disabled  >二氧化碳浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-002-CO2' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multC02Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multC02Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-002-CO2') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multC02Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multC02Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 温度（℃）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10' "  label="告警参数:" >
					<el-radio disabled  >温度（℃)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multHeatSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multHeatSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multHeatSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multHeatSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 湿度 (%）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10' "  label="告警参数:" >
					<el-radio disabled  >湿度（%RH）</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1') " label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multHumiditySetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multHumiditySetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multHumiditySetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multHumiditySetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 甲醛容度 (ppb) 参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-004-10' "  label="告警参数:" >
					<el-radio disabled  >甲醛容度 (ppb)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multArofeneSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multArofeneSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '1') "  label="预警范围:" style="display:inline;">
					<el-input v-model="multArofeneSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multArofeneSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- PM2.5 (ug/m³)参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-003-PM' "  label="告警参数:" >
					<el-radio disabled >PM2.5 (ug/m³)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-003-PM') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multPM25Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multPM25Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-003-PM') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multPM25Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multPM25Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- TOVC (ppb)参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-004-VOC' "  label="告警参数:" >
					<el-radio v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-VOC'" disabled >TVOC (ppb)</el-radio>
					<el-radio v-if="multSettingForm.deviceModel =='YS-ZN-026'" disabled >TVOC (ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-004-VOC') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="multTOVCSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multTOVCSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-004-VOC') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input v-model="multTOVCSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="multTOVCSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!--端智能振温传感器 高规版-->
				<el-form-item label="温度过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd01.overTemperatureSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="温度增幅过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd01.overTemperatureIncreaseSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd01.vibrationRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="低频加速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd01.lowFrequencyRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="高频加速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd01.highFrequencyRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>	

				<!--端智能振温传感器 常规版-->
				<el-form-item label="温度过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10' "  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd10.overTemperatureSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="温度增幅过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10' "  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd10.overTemperatureIncreaseSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd10.vibrationRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动加速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd10.vibrationAccelerateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动位移峰峰值报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10'"  prop="explainModel">
					<el-select  v-model="multSettingForm.vtd10.vibrationMovePeakSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				
				<el-form-item  prop="alarmTimeout" label="告警超时:" >
					<el-input v-model="multSettingForm.alarmTimeout" auto-complete="off"  placeholder="请输入1-3000的自然数" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">分钟</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelMultSettingSubmit">取消</el-button>
				<el-button type="primary" v-if="userRoleIdentity == 'admin'" v-bind:disabled="multSettingSubmitButtonDisabled" @click.native="multSettingSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--多元组 查看配置弹窗-->
		<el-dialog title="查看配置" v-model="showMultSettingFormVisible" :close-on-click-modal="false" @close="cancelShowMultSettingSubmit">
			<el-form :model="multSettingForm" label-width="160px" :rules="settingFormRules" ref="settingForm">
				<el-form-item prop="name" label="传感器名称:">
					 <span >{{multSettingForm.name}}</span>
				</el-form-item>
				<el-form-item prop="name" label="传感器类型:">
					 <span >{{multSettingForm.deviceModelName}}</span>
				</el-form-item>
				<el-form-item label="数据类型:" prop="dataType">
						<span v-if="multSettingForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="告警:" v-if="isYSZNDeviceType(multSettingForm.deviceModel)" prop="alarmType">
					<el-radio-group  v-model="multSettingForm.alarmType" >
						<el-radio disabled class="radio" :label="0">报警</el-radio>
						<el-radio disabled class="radio"  :label="-1">预警</el-radio>
						<el-radio disabled v-if="multSettingForm.dataType == '0'"  class="radio" :label="1">预警+报警</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- 硫化氢（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-012-H2S'"  label="告警参数:" >
					<el-radio disabled  >硫化氢浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-012-H2S' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multH2SSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multH2SSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-012-H2S'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multH2SSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multH2SSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				 <!-- 氨气（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-010-NH3'"  label="告警参数:" >
					<el-radio disabled  >氨气浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-010-NH3' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multNH3Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multNH3Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-010-NH3'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multNH3Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multNH3Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 一氧化碳（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-009-CO'"  label="告警参数:" >
					<el-radio disabled  >一氧化碳浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-009-CO' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multC0Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multC0Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-009-CO'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multC0Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multC0Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>

				<!-- 二氧化碳（ppm）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-002-CO2'"  label="告警参数:" >
					<el-radio disabled  >二氧化碳浓度(ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-002-CO2' && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multC02Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multC02Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-002-CO2'&& (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multC02Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multC02Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!-- 温度（℃）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10' "  label="告警参数:" >
					<el-radio disabled  >温度（℃)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multHeatSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multHeatSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multHeatSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multHeatSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!-- 湿度 (%）参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10' "  label="告警参数:" >
					<el-radio disabled  >湿度（%RH）</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1') " label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multHumiditySetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multHumiditySetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multHumiditySetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multHumiditySetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!-- 甲醛容度 (ppb) 参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-004-10' "  label="告警参数:" >
					<el-radio disabled  >甲醛容度 (ppb)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multArofeneSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multArofeneSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-004-10') && (multSettingForm.alarmType == '1') "  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multArofeneSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multArofeneSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!-- PM2.5 (ug/m³)参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-003-PM' "  label="告警参数:" >
					<el-radio disabled >PM2.5 (ug/m³)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-003-PM') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input disabled v-model="multPM25Setting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multPM25Setting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-025' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-003-PM') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multPM25Setting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multPM25Setting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!-- TOVC (ppb)参数设置-->
				<el-form-item v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-004-VOC' "  label="告警参数:" >
					<el-radio v-if="multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-004-VOC' " disabled >TVOC (ppb)</el-radio>
					<el-radio v-if="multSettingForm.deviceModel =='YS-ZN-026'" disabled >TVOC (ppm)</el-radio>
				</el-form-item>	
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-004-VOC') && (multSettingForm.alarmType == '0' || multSettingForm.alarmType == '-1' || multSettingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input  disabled v-model="multTOVCSetting.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multTOVCSetting.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="(multSettingForm.deviceModel =='YS-ZN-024' || multSettingForm.deviceModel =='YS-ZN-026' || multSettingForm.deviceModel =='YS-ZN-004-VOC') && (multSettingForm.alarmType == '1')"  label="预警范围:" style="display:inline;">
					<el-input disabled v-model="multTOVCSetting.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input disabled v-model="multTOVCSetting.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<!--端智能振温传感器 高规版-->
				<el-form-item label="温度过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd01.overTemperatureSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="温度增幅过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd01.overTemperatureIncreaseSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd01.vibrationRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="低频加速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd01.lowFrequencyRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="高频加速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD01'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd01.highFrequencyRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>	
				<!--端智能振温传感器 常规版-->
				<el-form-item label="温度过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10' "  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd10.overTemperatureSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="温度增幅过高报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10' "  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd10.overTemperatureIncreaseSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd10.vibrationRateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动加速度rms报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10'"  prop="explainModel">
					<el-select disabled v-model="multSettingForm.vtd10.vibrationAccelerateSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="振动位移峰峰值报警"  v-if="multSettingForm.deviceModel == 'AIoT-VTD10'"  prop="explainModel">
					<el-select disabled  v-model="multSettingForm.vtd10.vibrationMovePeakSetting.warnType"  placeholder="请选择" style="width: 300px">
				        <el-option  label="不开启" value="1"></el-option>
						<el-option  label="报警" value="0"></el-option>
						<el-option  label="预警" value="-1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item  prop="alarmTimeout" label="告警超时:" >
					<el-input disabled v-model="multSettingForm.alarmTimeout" auto-complete="off"  placeholder="请输入1-3000的自然数" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">分钟</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelShowMultSettingSubmit">取消</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				permissionNodeList:global.getPermissionNodeList(),
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				deviceModelList:[],
				editFormVisible: false,
				editLoading: false,
				saveFormRules: {
					name: [
						{ required: true, message: '名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					sn: [
						{ required: true, message: '编号不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					address: [
						{ required: true, message: '地址不能为空', trigger: 'blur' },
					],
					versionNumber: [
						{ required: true, message: '版本不能为空', trigger: 'blur' },
					],
					deviceModel:[
						{ required: true, message: '请选择数据类型'},
					],
					projectId:[
					    { required: true, message: '请选择所属项目'},
					],
					sysCode:[
					    { required: true, message: '请选择所属系统'},
					]
				},
				addForm: {
					
				},
				editForm: {

				},
				filterForm: {
					
				},
				sysAppList:[],
				sysAppListForTree:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/terminal/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				settingFormVisible:false,
				showSettingFormVisible:false,
				settingForm:{
					thresholdType:false,
					otherThresholdType:false,
				},
				multSettingFormVisible:false,
				multSettingSubmitButtonDisabled:false,
				showMultSettingFormVisible:false,
				multSettingForm:{
					alarmType:0,
					//多组配置
					confArrays:[],
					vtd01: {
						overTemperatureSetting:{},
						overTemperatureIncreaseSetting:{},
						vibrationRateSetting:{},
						lowFrequencyRateSetting:{},
						highFrequencyRateSetting:{}
					},
					vtd10: {
						overTemperatureSetting:{},
						overTemperatureIncreaseSetting:{},
						vibrationRateSetting:{},
						vibrationAccelerateSetting:{},
						vibrationMovePeakSetting:{}
					}
				},
				multSettingFormInitialize:{
					//多组配置
					confArrays:[],
					vtd01: {
						overTemperatureSetting:{},
						overTemperatureIncreaseSetting:{},
						vibrationRateSetting:{},
						lowFrequencyRateSetting:{},
						highFrequencyRateSetting:{}
					},
					vtd10: {
						overTemperatureSetting:{},
						overTemperatureIncreaseSetting:{},
						vibrationRateSetting:{},
						vibrationAccelerateSetting:{},
						vibrationMovePeakSetting:{}
					}
				},
				//温度
				multHeatSetting:{},
				//湿度
				multHumiditySetting:{},
				//甲醛
				multArofeneSetting:{},
				//pm2.5
				multPM25Setting:{},
				//TOVC
				multTOVCSetting:{},
				//硫化氢
				multH2SSetting:{},
				//氮气
				multNH3Setting:{},
				//一氧化碳
				multC0Setting:{},
				//二氧化碳
				multC02Setting:{},

				settingFormRules:{
					// alarmTimeout:[
					// 	{ required: true, message: '告警超时不能为空', trigger: 'blur' },
					// 	{ type: 'number', message: '告警超时必须为数字值', trigger: 'blur' },
					// ],
				},
				settingSubmitButtonDisabled:false,
				blockFormVisible:false,
				blockForm:{

				},
				blockFormRules:{

				},
				blockSubmitButtonDisabled:false,
				filterDeviceModel:'',
				filterSysCode:'',
				projectList:[],
			}
		},
		methods: {
			checkinlist(){
				 console.log(this.editForm.sysIdJoinCodes);
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					keys:this.search_word,
					pageNum: this.page,
					pageSize: 15
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterDeviceModel && this.filterDeviceModel.length>0) param.deviceModel = this.filterDeviceModel;
				if(null != this.filterSysCode && this.filterSysCode.length>0) param.sysCode = this.filterSysCode;
				this.listLoading = true;
				api.assetsManage_terminal_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleEdit: function (index, row) {	
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_terminal_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.editForm = Object.assign({}, res.data);
						if(this.editForm.deviceModel =='ECSLZT'){
							this.editForm.sysCode = this.editForm.sysCode.split(',');
						}
						this.editForm.projectId  = String(this.editForm.projectId);
						this.editFormVisible = true;
					}
					else{
						tools.error(new Vue(),"没有查询到该传感器详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				if(null != param.sysCode){
					if(param.sysCode == 'all')this.filterSysCode = '';
					else this.filterSysCode = param.sysCode;
				}
				if(null != param.deviceModel){
					if(param.deviceModel == 'all')this.filterDeviceModel = '';
					else this.filterDeviceModel = param.deviceModel;
				}
				this.get_list_data();
			},
			handleAdd: function () {
				let param = {};
				this.addFormVisible = true;
				this.addForm = {
					dataType:0,
					versionNumber:'0'
				};	
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let isValidateD4ACZTT = false; 
						let isValidateD4ACZT = false;
						if(this.addForm.deviceModel =='D4ACZT-T' ){
							isValidateD4ACZTT = true; 
						}
						if(this.addForm.deviceModel =='D4ACZT' ){
							isValidateD4ACZT = true; 
						}
						let isValidateECSLZT = false; 
						if(this.addForm.deviceModel =='ECSLZT' ){
							isValidateECSLZT = true; 
						}
						if((isValidateD4ACZTT ==true) || (isValidateD4ACZT ==true)){
							if((tools.strIsEmpty(this.addForm.rangeUpper) || tools.strIsEmpty(this.addForm.rangeLower))){
								tools.error(new Vue(),"量程上限或量程下限为空");
								this.addSubmitButtonDisabled=false;
								return;
							}
							if(parseInt(this.addForm.rangeUpper) ==NaN || (parseInt(this.addForm.rangeUpper) > 65535) || (parseInt(this.addForm.rangeUpper) < -65535)){
								tools.error(new Vue(),"量程上限请输入-65535-65535范围的数值");
								this.addSubmitButtonDisabled=false;
								return;
							}
							if(parseInt(this.addForm.rangeLower) ==NaN || (parseInt(this.addForm.rangeLower) > 65535) || (parseInt(this.addForm.rangeLower) < -65535)){
								tools.error(new Vue(),"量程下限请输入-65535-65535范围的数值");
								this.addSubmitButtonDisabled=false;
								return;
							}
							if(parseFloat(this.addForm.rangeLower) >= parseFloat(this.addForm.rangeUpper)){
								tools.error(new Vue(),"量程上限值必须大于量程下限");
								this.addSubmitButtonDisabled=false;
								return;
							}
						}
						if(isValidateECSLZT && this.addForm.sysCode){
							this.addForm.sysCode = this.addForm.sysCode.join(',');
						}
						let param = Object.assign({}, this.addForm);
						param.projectId = parseFloat(param.projectId);
						this.listLoading = true;
						let self = this;
						api.assetsManage_terminal_saveOrUpdate_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
            },
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						let isValidateD4ACZTT = false; 
						let isValidateD4ACZT = false;
						if(this.editForm.deviceModel =='D4ACZT-T' ){
							isValidateD4ACZTT = true; 
						}
						if(this.addForm.deviceModel =='D4ACZT' ){
							isValidateD4ACZT = true; 
						}
						let isValidateECSLZT = false; 
						if(this.editForm.deviceModel =='ECSLZT' ){
							isValidateECSLZT = true; 
						}
						if((isValidateD4ACZTT ==true) || (isValidateD4ACZT ==true)){
							if((tools.strIsEmpty(this.editForm.rangeUpper) || tools.strIsEmpty(this.editForm.rangeLower))){
								tools.error(new Vue(),"量程上限或量程下限为空");
								this.editSubmitButtonDisabled=false;
								return;
							}
							if(parseInt(this.editForm.rangeUpper) ==NaN || (parseInt(this.editForm.rangeUpper) > 65535) || (parseInt(this.editForm.rangeUpper) < -65535)){
								tools.error(new Vue(),"量程上限请输入-65535-65535范围的数值");
								this.editSubmitButtonDisabled=false;
								return;
							}
							if(parseInt(this.editForm.rangeLower) ==NaN || (parseInt(this.editForm.rangeLower) > 65535) || (parseInt(this.editForm.rangeLower) < -65535)){
								tools.error(new Vue(),"量程下限请输入-65535-65535范围的数值");
								this.editSubmitButtonDisabled=false;
								return;
							}
							if(parseFloat(this.editForm.rangeLower) >= parseFloat(this.editForm.rangeUpper)){
								tools.error(new Vue(),"量程上限值必须大于量程下限");
								this.editSubmitButtonDisabled=false;
								return;
							}
						}
						if(isValidateECSLZT && this.editForm.sysCode){
							this.editForm.sysCode = this.editForm.sysCode.join(',');
						}
						let param = Object.assign({}, this.editForm);
						param.projectId = parseFloat(param.projectId);
						this.listLoading = true;
						let self = this;
						api.assetsManage_terminal_saveOrUpdate_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							tools.success(this,"编辑成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			cancelSettingSubmit(){
				this.settingFormVisible = false;
				for (let index = 0; index < this.$refs.settingForm.fields.length; index++) {
					if((this.$refs.settingForm.fields[index] == undefined) || (this.$refs.settingForm.fields[index].prop == undefined))delete this.$refs.settingForm.fields[index];
				}
				this.$refs.settingForm.resetFields();
				if(this.settingSubmitButtonDisabled)this.settingSubmitButtonDisabled = false;
			},
			cancelMultSettingSubmit(){
				//mult
				this.multSettingFormVisible = false;
				for (let index = 0; index < this.$refs.multSettingForm.fields.length; index++) {
					if((this.$refs.multSettingForm.fields[index] == undefined) || (this.$refs.multSettingForm.fields[index].prop == undefined))delete this.$refs.multSettingForm.fields[index];
				}
				this.$refs.multSettingForm.resetFields();
				this.multHeatSetting = {};
				this.multHumiditySetting = {};
				this.multArofeneSetting = {};
				this.multPM25Setting = {};
				this.multTOVCSetting = {};
				if(this.settingSubmitButtonDisabled)this.settingSubmitButtonDisabled = false;
			},
			handleSetting: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_terminal_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						if(res.data.thresholdType ==1){
							res.data.thresholdType = true; 
						}
						else{
							res.data.thresholdType = false; 
						}
						if(res.data.otherThresholdType ==1){
							res.data.otherThresholdType = true; 
						}
						else{
							res.data.otherThresholdType = false; 
						}
						this.settingForm = Object.assign({}, res.data);
						if(this.settingForm.dataType == 'AI')this.settingForm.dataType = '0';
						else if(this.settingForm.dataType == 'DI')this.settingForm.dataType = '1';
						if(!tools.strIsEmpty(this.settingForm.deviceModel)){
							//判断是否多元组
							if((global.multDeviceModelList.indexOf(this.settingForm.deviceModel) == -1) && !(this.isYSZNDeviceType(this.settingForm.deviceModel))){
								this.settingFormVisible = true;
								if(this.settingForm.deviceModel == 'OCZ1ZT47-XY'){
									if(this.settingForm.oneExplain == "有人吸烟"){
										//无人吸烟
										this.settingForm.zeroExplain = '0';
										//有人吸烟
										this.settingForm.oneExplain = '1';
									}
									else if (this.settingForm.oneExplain == "无人吸烟"){ 
										//有人吸烟
										this.settingForm.zeroExplain = '1';
										//无人吸烟
										this.settingForm.oneExplain = '0';
										
									}
									if(this.settingForm.explainModel == 0){
										this.settingForm.explainModel = '1';
									}
								}
							}
							else{
								this.multHeatSetting = {},
								this.multHumiditySetting = {},
								this.multArofeneSetting = {},
								this.multPM25Setting = {},
								this.multTOVCSetting = {},
								this.multH2SSetting={},
								this.multNH3Setting={},
								this.multC0Setting={},
								this.multC02Setting={},
								this.multSettingForm.confArrays = JSON.parse(this.settingForm.confArrays);
								if(!tools.strIsEmpty(this.multSettingForm.confArrays)){
									this.multSettingForm.confArrays.forEach((item,index)=>{
										if(this.isYSZNDeviceType(this.settingForm.deviceModel)){
											if(item.code == 0){
												this.multHeatSettingVisible = true;
												this.multHeatSetting = item;
											}
											if(item.code == 1){
												this.multHumiditySettingVisible = true;
												this.multHumiditySetting = item;
											}
											if(item.code == 2){
												this.multTOVCSettingVisible = true;
												this.multTOVCSetting = item;
											}
											if(item.code == 3){
												this.multC02Setting = item;
											}
											if(item.code == 6){
												this.multPM25SettingVisible = true;
												this.multPM25Setting = item;
											}
											if(item.code == 9){
												this.multArofeneSettingVisible = true;
												this.multArofeneSetting = item;
											}
											if(item.code == 12){
												this.multH2SSetting = item;
											}
											if(item.code == 16){
												this.multNH3Setting = item;
											}
											if(item.code == 15){
												this.multC0Setting = item;
											}
										}
										else if(this.settingForm.deviceModel == 'AIoT-VTD01'){
											if(item.code == 0) this.multSettingForm.vtd01.overTemperatureSetting = item;
											if(item.code == 1) this.multSettingForm.vtd01.overTemperatureIncreaseSetting = item;
											if(item.code == 2) this.multSettingForm.vtd01.vibrationRateSetting = item;
											if(item.code == 3) this.multSettingForm.vtd01.lowFrequencyRateSetting = item;
											if(item.code == 4) this.multSettingForm.vtd01.highFrequencyRateSetting = item;
										}
										else if(this.settingForm.deviceModel == 'AIoT-VTD10'){
											if(item.code == 0) this.multSettingForm.vtd10.overTemperatureSetting = item;
											if(item.code == 1) this.multSettingForm.vtd10.overTemperatureIncreaseSetting = item;
											if(item.code == 2) this.multSettingForm.vtd10.vibrationRateSetting = item;
											if(item.code == 3) this.multSettingForm.vtd10.vibrationAccelerateSetting = item;
											if(item.code == 4) this.multSettingForm.vtd10.vibrationMovePeakSetting = item;

										}
										
									})
									}
								    this.multSettingForm.deviceId = this.settingForm.deviceId;
									this.multSettingForm.deviceModel = this.settingForm.deviceModel;
									this.multSettingForm.deviceModelName = this.settingForm.deviceModelName;
									this.multSettingForm.name = this.settingForm.name;
									this.multSettingForm.dataType = this.settingForm.dataType;
									this.multSettingForm.alarmType = this.settingForm.alarmType;
									this.multSettingForm.alarmTimeout = this.settingForm.alarmTimeout;
								    this.multSettingFormVisible = true;
								    console.log(this.multSettingForm)
							}

						}
						else{
							tools.error(new Vue(),"该设备数据标识不存在,请稍微重试");
						}
					}
					else{
						tools.error(new Vue(),"没有查询到该设备详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			handleShowSetting: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_terminal_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						if(res.data.thresholdType ==1){
							res.data.thresholdType = true; 
						}
						else{
							res.data.thresholdType = false; 
						}
						if(res.data.otherThresholdType ==1){
							res.data.otherThresholdType = true; 
						}
						else{
							res.data.otherThresholdType = false; 
						}
						this.settingForm = Object.assign({}, res.data);
						if(this.settingForm.dataType == 'AI')this.settingForm.dataType = '0';
						else if(this.settingForm.dataType == 'DI')this.settingForm.dataType = '1';
						if(!tools.strIsEmpty(this.settingForm.deviceModel)){
							//判断是否多元组
							if((global.multDeviceModelList.indexOf(this.settingForm.deviceModel) == -1) && !(this.isYSZNDeviceType(this.settingForm.deviceModel))){
								this.showSettingFormVisible = true;
								if(this.settingForm.deviceModel == 'OCZ1ZT47-XY'){
									if(this.settingForm.oneExplain == "有人吸烟"){
										//无人吸烟
										this.settingForm.zeroExplain = '0';
										//有人吸烟
										this.settingForm.oneExplain = '1';
									}
									else if (this.settingForm.oneExplain == "无人吸烟"){ 
										//有人吸烟
										this.settingForm.zeroExplain = '1';
										//无人吸烟
										this.settingForm.oneExplain = '0';
									}
									if(this.settingForm.explainModel == 0){
										this.settingForm.explainModel = '1';
									}
								}
							}
							else{
								this.multSettingForm = this.multSettingFormInitialize;
								this.multHeatSetting = {},
								this.multHumiditySetting = {},
								this.multArofeneSetting = {},
								this.multPM25Setting = {},
								this.multTOVCSetting = {},
								this.multH2SSetting={},
								this.multNH3Setting={},
								this.multC0Setting={},
								this.multC02Setting={},
								this.multSettingForm.deviceId = this.settingForm.deviceId;
								this.multSettingForm.deviceModel = this.settingForm.deviceModel;
								this.multSettingForm.deviceModelName = this.settingForm.deviceModelName;
								this.multSettingForm.name = this.settingForm.name;
								this.multSettingForm.dataType = this.settingForm.dataType;
								this.multSettingForm.alarmTimeout = this.settingForm.alarmTimeout;
								this.multSettingForm.confArrays = JSON.parse(this.settingForm.confArrays);
								if(!tools.strIsEmpty(this.multSettingForm.confArrays)){
									this.multSettingForm.confArrays.forEach((item,index)=>{
										if(this.isYSZNDeviceType(this.settingForm.deviceModel)){
											if(item.code == 0){
												this.multHeatSettingVisible = true;
												this.multHeatSetting = item;
											}
											if(item.code == 1){
												this.multHumiditySettingVisible = true;
												this.multHumiditySetting = item;
											}
											if(item.code == 2){
												this.multTOVCSettingVisible = true;
												this.multTOVCSetting = item;
											}
											if(item.code == 3){
												this.multC02Setting = item;
											}
											if(item.code == 6){
												this.multPM25SettingVisible = true;
												this.multPM25Setting = item;
											}
											if(item.code == 9){
												this.multArofeneSettingVisible = true;
												this.multArofeneSetting = item;
											}
											if(item.code == 12){
												this.multH2SSetting = item;
											}
											if(item.code == 16){
												this.multNH3Setting = item;
											}
											if(item.code == 15){
												this.multC0Setting = item;
											}
										}
										else if(this.settingForm.deviceModel == 'AIoT-VTD01'){
											if(item.code == 0) this.multSettingForm.vtd01.overTemperatureSetting = item;
											if(item.code == 1) this.multSettingForm.vtd01.overTemperatureIncreaseSetting = item;
											if(item.code == 2) this.multSettingForm.vtd01.vibrationRateSetting = item;
											if(item.code == 3) this.multSettingForm.vtd01.lowFrequencyRateSetting = item;
											if(item.code == 4) this.multSettingForm.vtd01.highFrequencyRateSetting = item;
										}
										else if(this.settingForm.deviceModel == 'AIoT-VTD10'){
											if(item.code == 0) this.multSettingForm.vtd10.overTemperatureSetting = item;
											if(item.code == 1) this.multSettingForm.vtd10.overTemperatureIncreaseSetting = item;
											if(item.code == 2) this.multSettingForm.vtd10.vibrationRateSetting = item;
											if(item.code == 3) this.multSettingForm.vtd10.vibrationAccelerateSetting = item;
											if(item.code == 4) this.multSettingForm.vtd10.vibrationMovePeakSetting = item;

										}
										
									})
								}
								this.multSettingForm.deviceId = this.settingForm.deviceId;
								this.multSettingForm.deviceModel = this.settingForm.deviceModel;
								this.multSettingForm.deviceModelName = this.settingForm.deviceModelName;
								this.multSettingForm.name = this.settingForm.name;
								this.multSettingForm.dataType = this.settingForm.dataType;
								this.multSettingForm.alarmType = this.settingForm.alarmType;
								this.multSettingForm.alarmTimeout = this.settingForm.alarmTimeout;
								this.showMultSettingFormVisible = true;
								console.log(this.multSettingForm)
							}

						}
					}
					else{
						tools.error(new Vue(),"没有查询到该设备详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			cancelShowSettingSubmit:function () {
				this.showSettingFormVisible = false;
			},
			cancelShowMultSettingSubmit:function () {
				this.showMultSettingFormVisible = false;
				this.multHeatSetting = {};
				this.multHumiditySetting = {};
				this.multArofeneSetting = {};
				this.multPM25Setting = {};
				this.multTOVCSetting = {};
				this.multH2SSetting={},
				this.multNH3Setting={},
				this.multC0Setting={},
				this.multC02Setting={},
				this.multSettingForm = this.multSettingFormInitialize;
			},
			settingSubmit: function () {
				this.$refs.settingForm.validate((valid) => {
					if (valid) {
						if(this.settingForm.dataType == 0){
							let isValidateThreshold = true; 
							let isValidateOtherThreshold = false; 
							if(this.settingForm.deviceModel =='THZ2ZT' || (this.settingForm.deviceModel =='VBZ3ZT' && this.settingForm.versionNumber =='5')){
								isValidateOtherThreshold = true; 
								if(this.settingForm.thresholdType ==0) {
									this.settingForm.lowerThreshold = "";
									this.settingForm.upperThreshold = "";
									this.settingForm.earlyLowerThreshold = "";
								    this.settingForm.earlyUpperThreshold = "";
									isValidateThreshold = false; 										
								}
								if(this.settingForm.otherThresholdType ==0) {
									this.settingForm.otherLowerThreshold = "";
									this.settingForm.otherUpperThreshold = "";
									this.settingForm.otherEarlyLowerThreshold = "";
									this.settingForm.otherEarlyUpperThreshold = "";
									isValidateOtherThreshold = false; 	
								}
							}
							else{
								if(this.settingForm.alarmType == 0  || this.settingForm.alarmType == -1){
									this.settingForm.earlyLowerThreshold = "";
									this.settingForm.earlyUpperThreshold = "";
									this.settingForm.otherEarlyLowerThreshold = "";
									this.settingForm.otherEarlyUpperThreshold = "";
								}
							}
							if((isValidateThreshold ==true) && (tools.strIsEmpty(this.settingForm.lowerThreshold) || tools.strIsEmpty(this.settingForm.upperThreshold))){
								tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
								return;
							}
							if((isValidateOtherThreshold ==true) && (tools.strIsEmpty(this.settingForm.otherLowerThreshold) || tools.strIsEmpty(this.settingForm.otherUpperThreshold))){
								if(this.settingForm.deviceModel =='THZ2ZT'){
									tools.error(new Vue(),"湿度（%）正常范围下限阈值或上限阈值为空");
								}
								else{
									tools.error(new Vue(),"熵值 正常范围下限阈值或上限阈值为空");
								}
								return;
							}
							if(this.settingForm.alarmType == 1){
								if((isValidateThreshold ==true) && (tools.strIsEmpty(this.settingForm.earlyLowerThreshold) || tools.strIsEmpty(this.settingForm.earlyUpperThreshold))){
									tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
									return;
								}
								if((isValidateOtherThreshold ==true) && (tools.strIsEmpty(this.settingForm.otherEarlyLowerThreshold) || tools.strIsEmpty(this.settingForm.otherEarlyUpperThreshold))){
									if(this.settingForm.deviceModel =='THZ2ZT'){
										tools.error(new Vue(),"湿度（%）预警范围下限阈值或上限阈值为空");
								    }
									else{
										tools.error(new Vue(),"熵值 预警范围下限阈值或上限阈值为空");
									}
									return;
								}
							}
						}
						if((!tools.strIsEmpty(this.settingForm.earlyLowerThreshold) && !tools.strIsEmpty(this.settingForm.earlyUpperThreshold) ) && (parseFloat(this.settingForm.earlyLowerThreshold) >= parseFloat(this.settingForm.earlyUpperThreshold))){
							tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
							return;
						}
						if((!tools.strIsEmpty(this.settingForm.lowerThreshold) && !tools.strIsEmpty(this.settingForm.upperThreshold)) && (parseFloat(this.settingForm.lowerThreshold) >= parseFloat(this.settingForm.upperThreshold))){
							tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
							return;
						}
						if( (!tools.strIsEmpty(this.settingForm.otherEarlyLowerThreshold) && !tools.strIsEmpty(this.settingForm.earlyUpperThreshold) ) && (parseFloat(this.settingForm.otherEarlyLowerThreshold) >= parseFloat(this.settingForm.otherEarlyUpperThreshold))){
							if(this.settingForm.deviceModel =='THZ2ZT'){
								tools.error(new Vue(),"湿度（%）预警范围下限阈值必须小于预警范围上限阈值");
							}
							else{
								tools.error(new Vue(),"熵值 预警范围下限阈值必须小于预警范围上限阈值");
							}
							return;
						}
						if((!tools.strIsEmpty(this.settingForm.otherLowerThreshold) && !tools.strIsEmpty(this.settingForm.otherUpperThreshold)) && (parseFloat(this.settingForm.otherLowerThreshold) >= parseFloat(this.settingForm.otherUpperThreshold))){
							if(this.settingForm.deviceModel =='THZ2ZT'){
								tools.error(new Vue(),"湿度（%）正常范围下限阈值必须小于正常范围上限阈值");
							}
							else{
								tools.error(new Vue(),"熵值 正常范围下限阈值必须小于正常范围上限阈值");
							}
							return;
						}
						if((!tools.strIsEmpty(this.settingForm.lowerThreshold) && !tools.strIsEmpty(this.settingForm.upperThreshold) ) && (!tools.strIsEmpty(this.settingForm.earlyLowerThreshold) && !tools.strIsEmpty(this.settingForm.earlyUpperThreshold) )){
							if(parseFloat(this.settingForm.lowerThreshold) <= parseFloat(this.settingForm.earlyLowerThreshold)){
								tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
							    return;
							}
							if(parseFloat(this.settingForm.upperThreshold) >= parseFloat(this.settingForm.earlyUpperThreshold)){
								tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
							    return;
							}
						}
						if((!tools.strIsEmpty(this.settingForm.otherLowerThreshold) && !tools.strIsEmpty(this.settingForm.otherUpperThreshold) ) && (!tools.strIsEmpty(this.settingForm.otherEarlyLowerThreshold) && !tools.strIsEmpty(this.settingForm.otherEarlyUpperThreshold) )){
							if(parseFloat(this.settingForm.otherLowerThreshold) <= parseFloat(this.settingForm.otherEarlyLowerThreshold)){
								if(this.settingForm.deviceModel =='THZ2ZT'){
								    tools.error(new Vue(),"湿度（%）正常范围下限阈值必须大于预警范围下限阈值");
								}
								else{
									tools.error(new Vue(),"熵值 正常范围下限阈值必须大于预警范围下限阈值");
								}
							    return;
							}
							if(parseFloat(this.settingForm.otherUpperThreshold) >= parseFloat(this.settingForm.otherEarlyUpperThreshold)){
								if(this.settingForm.deviceModel =='THZ2ZT'){
								    tools.error(new Vue(),"湿度（%）正常范围上限阈值必须小于预警范围上限阈值");
								}
								else{
									tools.error(new Vue(),"熵值 正常范围上限阈值必须小于预警范围上限阈值");
								}
							    return;
							}
						}
						if(tools.strIsEmpty(this.settingForm.alarmTimeout)){
							tools.error(new Vue(),"告警超时不能为空");
							return;
						}
						if(isNaN(parseInt(this.settingForm.alarmTimeout))){
							tools.error(new Vue(),"告警超时请输入数字");
							return;
						}
						if(parseInt(this.settingForm.alarmTimeout) ==NaN || (parseInt(this.settingForm.alarmTimeout)<1) || (parseInt(this.settingForm.alarmTimeout)>3000)){
							tools.error(new Vue(),"请输入1-3000的自然数");
							return;
						}
						if(this.settingForm.thresholdType ==1){
							this.settingForm.thresholdType = 1; 
						}
						else{
							this.settingForm.thresholdType = 0; 
						}
						if(this.settingForm.otherThresholdType ==1){
							this.settingForm.otherThresholdType = 1; 
						}
						else{
							this.settingForm.otherThresholdType = 0; 
						}
						
						if(this.settingForm.deviceModel == 'OCZ1ZT47-XY'){
							if(this.settingForm.zeroExplain == '1'){
								//无人吸烟
								this.settingForm.zeroExplain = "无人吸烟";
								//有人吸烟
								this.settingForm.oneExplain = "有人吸烟";

							}
							else if (this.settingForm.zeroExplain == '0'){ 
								//有人吸烟
								this.settingForm.zeroExplain = "有人吸烟";
								//无人吸烟
								this.settingForm.oneExplain = "无人吸烟";
								if(this.settingForm.explainModel == '1'){
								   this.settingForm.explainModel = '0';
								}
							}
						}
						this.listLoading = true;
						this.settingSubmitButtonDisabled=true;
						let param = Object.assign({}, this.settingForm);
						api.assetsManage_terminal_setAlarmStatusRule_request(param).then(
							res => {
								this.listLoading = false;
								this.settingFormVisible = false;
								for (let index = 0; index < this.$refs.settingForm.fields.length; index++) {
									if((this.$refs.settingForm.fields[index] == undefined) || (this.$refs.settingForm.fields[index].prop == undefined))delete this.$refs.settingForm.fields[index];
								}
								this.$refs.settingForm.resetFields();
								this.settingSubmitButtonDisabled=false;
								tools.success(this,"配置成功");
								this.get_list_data();
							}
						).catch(function (e) {
							console.log(e);
							self.settingSubmitButtonDisabled=false;
							if(e.message)tools.error(new Vue(),e.message);
							this.listLoading = false;
						});	
					}
				})
			},
			
			multSettingSubmit: function() {
				this.$refs.multSettingForm.validate((valid) => {
					if (valid) {
						if(tools.strIsEmpty(this.multSettingForm.alarmTimeout)){
							tools.error(new Vue(),"告警超时不能为空");
							return;
						}
						if(isNaN(parseInt(this.multSettingForm.alarmTimeout))){
							tools.error(new Vue(),"告警超时请输入数字");
							return;
						}
						if(parseInt(this.multSettingForm.alarmTimeout) ==NaN || (parseInt(this.multSettingForm.alarmTimeout)<1) || (parseInt(this.multSettingForm.alarmTimeout)>3000)){
							tools.error(new Vue(),"请输入1-3000的自然数");
							return;
						}
						let param = Object.assign({}, this.multSettingForm);
						param.confArrays = [];
						if(this.isYSZNDeviceType(this.multSettingForm.deviceModel)){
							if(!tools.strIsEmpty(this.multHeatSetting) && Object.keys(this.multHeatSetting).length >0) {
								this.multHeatSetting.code = 0;
								this.multHeatSetting.enable = 1;
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multHeatSetting.lowerThreshold) || tools.strIsEmpty(this.multHeatSetting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multHeatSetting.earlyLowerThreshold) || tools.strIsEmpty(this.multHeatSetting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multHeatSetting.lowerThreshold) && !tools.strIsEmpty(this.multHeatSetting.upperThreshold)) && (parseFloat(this.multHeatSetting.lowerThreshold) >= parseFloat(this.multHeatSetting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multHeatSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multHeatSetting.earlyUpperThreshold) ) && (parseFloat(this.multHeatSetting.earlyLowerThreshold) >= parseFloat(this.multHeatSetting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multHeatSetting.lowerThreshold) && !tools.strIsEmpty(this.multHeatSetting.upperThreshold) ) && (!tools.strIsEmpty(this.multHeatSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multHeatSetting.earlyUpperThreshold) )){
										if(parseFloat(this.multHeatSetting.lowerThreshold) <= parseFloat(this.multHeatSetting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multHeatSetting.upperThreshold) >= parseFloat(this.multHeatSetting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								   }
								}
								
								param.confArrays.push(this.multHeatSetting)
							}
							if(!tools.strIsEmpty(this.multHumiditySetting && Object.keys(this.multHumiditySetting).length >0)) {
								this.multHumiditySetting.code = 1;
								this.multHumiditySetting.enable = 1
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multHumiditySetting.lowerThreshold) || tools.strIsEmpty(this.multHumiditySetting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multHumiditySetting.earlyLowerThreshold) || tools.strIsEmpty(this.multHumiditySetting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multHumiditySetting.lowerThreshold) && !tools.strIsEmpty(this.multHumiditySetting.upperThreshold)) && (parseFloat(this.multHumiditySetting.lowerThreshold) >= parseFloat(this.multHumiditySetting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multHumiditySetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multHumiditySetting.earlyUpperThreshold) ) && (parseFloat(this.multHumiditySetting.earlyLowerThreshold) >= parseFloat(this.multHumiditySetting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								     }
									if((!tools.strIsEmpty(this.multHumiditySetting.lowerThreshold) && !tools.strIsEmpty(this.multHumiditySetting.upperThreshold) ) && (!tools.strIsEmpty(this.multHumiditySetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multHumiditySetting.earlyUpperThreshold) )){
										if(parseFloat(this.multHumiditySetting.lowerThreshold) <= parseFloat(this.multHumiditySetting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multHumiditySetting.upperThreshold) >= parseFloat(this.multHumiditySetting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								    }
								}
								
								param.confArrays.push(this.multHumiditySetting)
							}
							if(!tools.strIsEmpty(this.multTOVCSetting) &&  Object.keys(this.multTOVCSetting).length >0) {
								this.multTOVCSetting.code = 2;
								this.multTOVCSetting.enable = 1
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multTOVCSetting.lowerThreshold) || tools.strIsEmpty(this.multTOVCSetting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multTOVCSetting.earlyLowerThreshold) || tools.strIsEmpty(this.multTOVCSetting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multTOVCSetting.lowerThreshold) && !tools.strIsEmpty(this.multTOVCSetting.upperThreshold)) && (parseFloat(this.multTOVCSetting.lowerThreshold) >= parseFloat(this.multTOVCSetting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}

								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multTOVCSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multTOVCSetting.earlyUpperThreshold) ) && (parseFloat(this.multTOVCSetting.earlyLowerThreshold) >= parseFloat(this.multTOVCSetting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multTOVCSetting.lowerThreshold) && !tools.strIsEmpty(this.multTOVCSetting.upperThreshold) ) && (!tools.strIsEmpty(this.multTOVCSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multTOVCSetting.earlyUpperThreshold) )){
										if(parseFloat(this.multTOVCSetting.lowerThreshold) <= parseFloat(this.multTOVCSetting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multTOVCSetting.upperThreshold) >= parseFloat(this.multTOVCSetting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								   }
								}
								param.confArrays.push(this.multTOVCSetting)
							}
							if(!tools.strIsEmpty(this.multPM25Setting) && Object.keys(this.multPM25Setting).length >0) {
								this.multPM25Setting.code = 6;
								this.multPM25Setting.enable = 1
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multPM25Setting.lowerThreshold) || tools.strIsEmpty(this.multPM25Setting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multPM25Setting.earlyLowerThreshold) || tools.strIsEmpty(this.multPM25Setting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multPM25Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multPM25Setting.earlyUpperThreshold) ) && (parseFloat(this.multPM25Setting.earlyLowerThreshold) >= parseFloat(this.multPM25Setting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multPM25Setting.lowerThreshold) && !tools.strIsEmpty(this.multPM25Setting.upperThreshold) ) && (!tools.strIsEmpty(this.multPM25Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multPM25Setting.earlyUpperThreshold) )){
										if(parseFloat(this.multPM25Setting.lowerThreshold) <= parseFloat(this.multPM25Setting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multPM25Setting.upperThreshold) >= parseFloat(this.multPM25Setting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								    }
								}
								
								if((!tools.strIsEmpty(this.multPM25Setting.lowerThreshold) && !tools.strIsEmpty(this.multPM25Setting.upperThreshold)) && (parseFloat(this.multPM25Setting.lowerThreshold) >= parseFloat(this.multPM25Setting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								param.confArrays.push(this.multPM25Setting)
							}
							if(!tools.strIsEmpty(this.multArofeneSetting) && Object.keys(this.multArofeneSetting).length >0) {
								this.multArofeneSetting.code =9;
								this.multArofeneSetting.enable = 1
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multArofeneSetting.lowerThreshold) || tools.strIsEmpty(this.multArofeneSetting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multArofeneSetting.earlyLowerThreshold) || tools.strIsEmpty(this.multArofeneSetting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multArofeneSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multArofeneSetting.earlyUpperThreshold) ) && (parseFloat(this.multArofeneSetting.earlyLowerThreshold) >= parseFloat(this.multArofeneSetting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multArofeneSetting.lowerThreshold) && !tools.strIsEmpty(this.multArofeneSetting.upperThreshold) ) && (!tools.strIsEmpty(this.multArofeneSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multArofeneSetting.earlyUpperThreshold) )){
										if(parseFloat(this.multArofeneSetting.lowerThreshold) <= parseFloat(this.multArofeneSetting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multArofeneSetting.upperThreshold) >= parseFloat(this.multArofeneSetting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								    }
								}
								if((!tools.strIsEmpty(this.multArofeneSetting.lowerThreshold) && !tools.strIsEmpty(this.multArofeneSetting.upperThreshold)) && (parseFloat(this.multArofeneSetting.lowerThreshold) >= parseFloat(this.multArofeneSetting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								param.confArrays.push(this.multArofeneSetting)
							}
							if(!tools.strIsEmpty(this.multC02Setting) && Object.keys(this.multC02Setting).length >0) {
								this.multC02Setting.code = 3;
								this.multC02Setting.enable = 1;
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multC02Setting.lowerThreshold) || tools.strIsEmpty(this.multC02Setting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multC02Setting.earlyLowerThreshold) || tools.strIsEmpty(this.multC02Setting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multC02Setting.lowerThreshold) && !tools.strIsEmpty(this.multC02Setting.upperThreshold)) && (parseFloat(this.multC02Setting.lowerThreshold) >= parseFloat(this.multC02Setting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multC02Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multC02Setting.earlyUpperThreshold) ) && (parseFloat(this.multC02Setting.earlyLowerThreshold) >= parseFloat(this.multC02Setting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multC02Setting.lowerThreshold) && !tools.strIsEmpty(this.multC02Setting.upperThreshold) ) && (!tools.strIsEmpty(this.multC02Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multC02Setting.earlyUpperThreshold) )){
										if(parseFloat(this.multC02Setting.lowerThreshold) <= parseFloat(this.multC02Setting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multC02Setting.upperThreshold) >= parseFloat(this.multC02Setting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								   }
								}
								
								param.confArrays.push(this.multC02Setting)
							}
							if(!tools.strIsEmpty(this.multC0Setting) && Object.keys(this.multC0Setting).length >0) {
								this.multC0Setting.code = 15;
								this.multC0Setting.enable = 1;
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multC0Setting.lowerThreshold) || tools.strIsEmpty(this.multC0Setting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multC0Setting.earlyLowerThreshold) || tools.strIsEmpty(this.multC0Setting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multC0Setting.lowerThreshold) && !tools.strIsEmpty(this.multC0Setting.upperThreshold)) && (parseFloat(this.multC0Setting.lowerThreshold) >= parseFloat(this.multC0Setting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multC0Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multC0Setting.earlyUpperThreshold) ) && (parseFloat(this.multC0Setting.earlyLowerThreshold) >= parseFloat(this.multC0Setting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multC0Setting.lowerThreshold) && !tools.strIsEmpty(this.multC0Setting.upperThreshold) ) && (!tools.strIsEmpty(this.multC0Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multC0Setting.earlyUpperThreshold) )){
										if(parseFloat(this.multC0Setting.lowerThreshold) <= parseFloat(this.multC0Setting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multC0Setting.upperThreshold) >= parseFloat(this.multC0Setting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								   }
								}
								
								param.confArrays.push(this.multC0Setting)
							}
							if(!tools.strIsEmpty(this.multH2SSetting) && Object.keys(this.multH2SSetting).length >0) {
								this.multH2SSetting.code = 12;
								this.multH2SSetting.enable = 1;
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multH2SSetting.lowerThreshold) || tools.strIsEmpty(this.multH2SSetting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multH2SSetting.earlyLowerThreshold) || tools.strIsEmpty(this.multH2SSetting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multH2SSetting.lowerThreshold) && !tools.strIsEmpty(this.multH2SSetting.upperThreshold)) && (parseFloat(this.multH2SSetting.lowerThreshold) >= parseFloat(this.multH2SSetting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multH2SSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multH2SSetting.earlyUpperThreshold) ) && (parseFloat(this.multH2SSetting.earlyLowerThreshold) >= parseFloat(this.multH2SSetting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multH2SSetting.lowerThreshold) && !tools.strIsEmpty(this.multH2SSetting.upperThreshold) ) && (!tools.strIsEmpty(this.multH2SSetting.earlyLowerThreshold) && !tools.strIsEmpty(this.multH2SSetting.earlyUpperThreshold) )){
										if(parseFloat(this.multH2SSetting.lowerThreshold) <= parseFloat(this.multH2SSetting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multH2SSetting.upperThreshold) >= parseFloat(this.multH2SSetting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								   }
								}
								
								param.confArrays.push(this.multH2SSetting)
							}

							if(!tools.strIsEmpty(this.multNH3Setting) && Object.keys(this.multNH3Setting).length >0) {
								this.multNH3Setting.code = 16;
								this.multNH3Setting.enable = 1;
								if(this.multSettingForm.dataType == 0){
									if((tools.strIsEmpty(this.multNH3Setting.lowerThreshold) || tools.strIsEmpty(this.multNH3Setting.upperThreshold))){
										tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
										return;
									}
									if(this.multSettingForm.alarmType == 1){
										if((tools.strIsEmpty(this.multNH3Setting.earlyLowerThreshold) || tools.strIsEmpty(this.multNH3Setting.earlyUpperThreshold))){
											tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
											return;
										}
									}
						        }
								
								if((!tools.strIsEmpty(this.multNH3Setting.lowerThreshold) && !tools.strIsEmpty(this.multNH3Setting.upperThreshold)) && (parseFloat(this.multNH3Setting.lowerThreshold) >= parseFloat(this.multNH3Setting.upperThreshold))){
									tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
									return;
								}
								
								if(this.multSettingForm.alarmType == 1){
									if((!tools.strIsEmpty(this.multNH3Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multNH3Setting.earlyUpperThreshold) ) && (parseFloat(this.multNH3Setting.earlyLowerThreshold) >= parseFloat(this.multNH3Setting.earlyUpperThreshold))){
										tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
										return;
								    }
									if((!tools.strIsEmpty(this.multNH3Setting.lowerThreshold) && !tools.strIsEmpty(this.multNH3Setting.upperThreshold) ) && (!tools.strIsEmpty(this.multNH3Setting.earlyLowerThreshold) && !tools.strIsEmpty(this.multNH3Setting.earlyUpperThreshold) )){
										if(parseFloat(this.multNH3Setting.lowerThreshold) <= parseFloat(this.multNH3Setting.earlyLowerThreshold)){
											tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
											return;
										}
										if(parseFloat(this.multNH3Setting.upperThreshold) >= parseFloat(this.multNH3Setting.earlyUpperThreshold)){
											tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
											return;
										}
								   }
								}
								
								param.confArrays.push(this.multNH3Setting)
							}
						}
						else if(this.multSettingForm.deviceModel == 'AIoT-VTD01'){
							if(!tools.strIsEmpty(this.multSettingForm.vtd01.overTemperatureSetting) && Object.keys(this.multSettingForm.vtd01.overTemperatureSetting).length >0) {
								this.multSettingForm.vtd01.overTemperatureSetting.code = 0;
								param.confArrays.push(this.multSettingForm.vtd01.overTemperatureSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd01.overTemperatureIncreaseSetting) && Object.keys(this.multSettingForm.vtd01.overTemperatureIncreaseSetting).length >0) {
								this.multSettingForm.vtd01.overTemperatureIncreaseSetting.code = 1;
								param.confArrays.push(this.multSettingForm.vtd01.overTemperatureIncreaseSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd01.vibrationRateSetting) && Object.keys(this.multSettingForm.vtd01.vibrationRateSetting).length >0) {
								this.multSettingForm.vtd01.vibrationRateSetting.code = 2;
								param.confArrays.push(this.multSettingForm.vtd01.vibrationRateSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd01.lowFrequencyRateSetting) && Object.keys(this.multSettingForm.vtd01.lowFrequencyRateSetting).length >0) {
								this.multSettingForm.vtd01.lowFrequencyRateSetting.code = 3;
								param.confArrays.push(this.multSettingForm.vtd01.lowFrequencyRateSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd01.highFrequencyRateSetting) && Object.keys(this.multSettingForm.vtd01.highFrequencyRateSetting).length >0) {
								this.multSettingForm.vtd01.highFrequencyRateSetting.code = 4;
								param.confArrays.push(this.multSettingForm.vtd01.highFrequencyRateSetting)
							}
						}
						else if(this.multSettingForm.deviceModel == 'AIoT-VTD10'){
							if(!tools.strIsEmpty(this.multSettingForm.vtd10.overTemperatureSetting) && Object.keys(this.multSettingForm.vtd10.overTemperatureSetting).length >0) {
								this.multSettingForm.vtd10.overTemperatureSetting.code = 0;
								param.confArrays.push(this.multSettingForm.vtd10.overTemperatureSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd10.overTemperatureIncreaseSetting) && Object.keys(this.multSettingForm.vtd10.overTemperatureIncreaseSetting).length >0) {
								this.multSettingForm.vtd10.overTemperatureIncreaseSetting.code = 1;
								param.confArrays.push(this.multSettingForm.vtd10.overTemperatureIncreaseSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd10.vibrationRateSetting) && Object.keys(this.multSettingForm.vtd10.vibrationRateSetting).length >0) {
								this.multSettingForm.vtd10.vibrationRateSetting.code = 2;
								param.confArrays.push(this.multSettingForm.vtd10.vibrationRateSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd10.vibrationAccelerateSetting) && Object.keys(this.multSettingForm.vtd10.vibrationAccelerateSetting).length >0) {
								this.multSettingForm.vtd10.vibrationAccelerateSetting.code = 3;
								param.confArrays.push(this.multSettingForm.vtd10.vibrationAccelerateSetting)
							}
							if(!tools.strIsEmpty(this.multSettingForm.vtd10.vibrationMovePeakSetting) && Object.keys(this.multSettingForm.vtd10.vibrationMovePeakSetting).length >0) {
								this.multSettingForm.vtd10.vibrationMovePeakSetting.code = 4;
								param.confArrays.push(this.multSettingForm.vtd10.vibrationMovePeakSetting)
							}
						}
						this.listLoading = true;
						this.multSettingSubmitButtonDisabled=true;
						this.$delete(param,'vtd10');
						this.$delete(param,'vtd01');
						api.assetsManage_terminal_setAlarmStatusRule_request(param).then(
							res => {
								this.listLoading = false;
								this.multSettingFormVisible = false;
								for (let index = 0; index < this.$refs.multSettingForm.fields.length; index++) {
									if((this.$refs.multSettingForm.fields[index] == undefined) || (this.$refs.multSettingForm.fields[index].prop == undefined))delete this.$refs.multSettingForm.fields[index];
								}
								this.$refs.multSettingForm.resetFields();
								this.multSettingSubmitButtonDisabled=false;
								this.multSettingForm = this.multSettingFormInitialize;
								this.multHeatSetting = {};
								this.multHumiditySetting = {};
								this.multArofeneSetting = {};
								this.multPM25Setting = {};
								this.multTOVCSetting = {};
								this.multH2SSetting={},
								this.multNH3Setting={},
								this.multC0Setting={},
								this.multC02Setting={},
								tools.success(this,"配置成功");
								this.get_list_data();
							}
						).catch(function (e) {
							//console.log(e);
							self.multSettingSubmitButtonDisabled=false;
							if(e.message)tools.error(new Vue(),e.message);
							this.listLoading = false;
						});	
						this.listLoading = false;
					}
				})
			},

			cancelBlockSubmit(){
				this.blockFormVisible = false;
				this.$refs.blockForm.resetFields();
				if(this.blockSubmitButtonDisabled)this.blockSubmitButtonDisabled = false;
			},
			handleBlock: function (index, row) {
				this.blockFormVisible = true;
				this.blockForm.name  = row.name;
				this.blockForm.deviceModelName  = row.deviceModelName;
				this.blockForm.deviceId  = row.deviceId;

			},
			blockSubmit: function () {
				this.$refs.blockForm.validate((valid) => {
					if (valid) {
						this.listLoading = true;
						this.blockSubmitButtonDisabled=true;
						let param = Object.assign({}, this.blockForm);
						if(null != param.startTime){
							param.startTime=param.startTime.getFullYear() + '-' + (param.startTime.getMonth() + 1) + '-' + param.startTime.getDate() + ' ' + param.startTime.getHours() + ':' + param.startTime.getMinutes();
						}
						if(null != param.endTime){
							param.endTime=param.endTime.getFullYear() + '-' + (param.endTime.getMonth() + 1) + '-' + param.endTime.getDate() + ' ' + param.endTime.getHours() + ':' + param.endTime.getMinutes();
						}
						param.alarmIgnoreAble = 1;
						api.assetsManage_terminal_setAlarmPolicy_request(param).then(
							res => {
								this.blockFormVisible = false;
								this.$refs.blockForm.resetFields();
								this.blockSubmitButtonDisabled=false;
								tools.success(this,"配置成功");
								this.get_list_data();
							}
						).catch(function (e) {
							console.log(e);
							self.blockSubmitButtonDisabled=false;
							if(e.message)tools.error(new Vue(),e.message);
						});	
					}
				})
			},
			handleUnBlock: function (index, row) {
				this.$confirm('确认取消告警屏蔽?', '提示',{showClose:false}).then(() => {
					let param = { deviceId:row.deviceId,alarmIgnoreAble: 0};
					api.assetsManage_terminal_setAlarmPolicy_request(param).then(
						res => {
							tools.success(this,"取消成功");
							this.get_list_data();
						}
					)	
				}).catch((e) => {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
			},
			getSysAppList: function () {
				let param = {};
				api.assetsManage_terminal_getSysAppList_request(param).then((res) => {
					this.sysAppList = res.data;	
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].key ,label:res.data[index].name};
					}
					this.sysAppListForTree = temp;
				}).catch((e) => {
					console.log(e);
				});
			},
			getDeviceModelList: function () {
				let param = {dataType:''};
				api.assetsManage_terminal_getDeviceModelList_request(param).then((res) => {
					if(res.data){
						this.deviceModelList = res.data;	
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseFloat(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			handleBatchDelete:function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择要删除的数据");
					return
				}
				this.$confirm('确认删除吗?', '提示', {showClose:false}).then(() => {
				    let param = {ids:this.tableSelectionIds};
					api.assetsManage_terminal_batchRemove_request(param).then(
						res => {
							if(res.code == 200){
								tools.success(this,"删除成功");
							    this.get_list_data();
							}
							else{
								tools.error(new Vue(),res.msg);
							}
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });	
				})
				.catch(function(e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				 });
			},
			downloadTemplate(){
				let param = {};
				api.assetsManage_terminal_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_assetsManageTerminalList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleUploadExceed(files, fileList){
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					keys:this.filterForm.search_word,
				};
				if(null != this.filterForm.deviceModel){
					if(this.filterForm.deviceModel == 'all')this.filterDeviceModel = '';
					else this.filterDeviceModel = this.filterForm.deviceModel;
				}
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterDeviceModel && this.filterDeviceModel.length>0) param.deviceModel = this.filterDeviceModel;
				if(null != this.filterForm.sysCode){
					if(this.filterForm.sysCode == 'all')this.filterSysCode = '';
					else this.filterSysCode = this.filterForm.sysCode;
				}
				if(null != this.filterSysCode && this.filterSysCode.length>0) param.sysCode = this.filterSysCode;
				this.listLoading = true;
				api.assetsManage_terminal_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'assetsManageFASList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				this.listLoading = true;
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			},
			isYSZNDeviceType: function (deviceType) {
				var deviceType = new String(deviceType);
				return deviceType.startsWith("YS-ZN");
			},
		},
		mounted() {
			this.get_list_data();
			this.getSysAppList();
			this.getDeviceModelList();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// terminal_list.vue?21b1b6db